import type { VoidFunctionComponent } from 'react';

import { nuc } from '../../../../../utils';
import Flex from '../../../../generic/Flex';
import Link from '../../../../generic/Link/Link';

import styles from '../FileViewer.module.less';

type Props = {
  revisionLocator: string;
  filePath: string;
};

export const FileViewerFileContentsTooLarge: VoidFunctionComponent<Props> = ({ revisionLocator, filePath }) => (
  <div className={styles.error}>
    <Flex direction="row" align="start" justify="left" gap="4px">
      <div>
        This file is too large to be displayed.
      </div>
      <Link
        to={`/api/revisions/${nuc(revisionLocator)}/blob/${nuc(filePath)}`}
        openInNewTab
        variant="primary"
        testId="file-viewer-view-raw-link"
      >
        View raw file
      </Link>
    </Flex>
  </div>
);
